import React from "react"
import Link from "gatsby-link"

import TopNav from "./topnav"
import Menu from "./menu"
import ImageSurface from "./util/image-surface"
import VideoSurface from "./util/video-surface"

import { NavigationDataItem } from "../utils/extract-navigation"
import { PageFieldsFragment } from "../../graphql-types"

export interface PageHeaderProps {
  title?: string
  sectionTitle?: string
  navigationData: NavigationDataItem[]
  navigationSecondaryData: NavigationDataItem[]
  variant?: "hasTitle" | "dark" | "o-row-mobile" | "headline"
  headerImage?: {
    url_s?: string
    url_m?: string
    url_l?: string
    url_xl?: string
    blurhash?: string
    width?: number
    height?: number
    focalPoint?: {
      y?: number
    }
  }
  headerVideo?: PageFieldsFragment["headerVideo"]["video"]
}

const PageHeader: React.FC<PageHeaderProps> = props => {
  const navigationData = props.navigationData || []
  const hasTitle = !!(props.title || props.sectionTitle)
  const darkBackground = !!props.headerImage?.url_m
  const headerImage = {
    url: props.headerImage?.url_m,
    sources: [
      {
        media: "min-width: 1200px",
        srcSet: `${props.headerImage?.url_l} 1x, ${props.headerImage?.url_xl} 2x`,
      },
      {
        media: "min-width: 640px",
        srcSet: `${props.headerImage?.url_m} 1x, ${props.headerImage?.url_l} 2x`,
      },
      {
        media: "min-width: 320px",
        srcSet: `${props.headerImage?.url_s} 1x, ${props.headerImage?.url_m} 2x`,
      },
    ],
    blurhash: props.headerImage?.blurhash,
    width: props.headerImage?.width,
    height: props.headerImage?.height,
    focalPoint: props.headerImage?.focalPoint,
  }

  const titleElement = () => {
    switch (true) {
      case !!(props.title && props.sectionTitle):
        return (
          <>
            <p className="c-heading--f">{props.sectionTitle}</p>
            <h1 className="u-visually-hidden">{props.title}</h1>
          </>
        )
      case !!props.title:
        return <h1 className="c-heading--f">{props.title}</h1>
      case !!props.sectionTitle:
        return <p className="c-heading--f">{props.sectionTitle}</p>
    }
  }

  return (
    <section
      className={`c-page-header ${props.variant ? props.variant : ""}${
        darkBackground ? " -dark" : ""
      }${hasTitle ? " -hasTitle" : ""}`}
    >
      {headerImage && <ImageSurface {...headerImage} />}
      {props.headerVideo && <VideoSurface video={props.headerVideo} />}
      <div className="o-wrapper u-flex">
        <Link
          to="/"
          className={`c-logo o-row ${darkBackground ? "" : "-dark"}`}
        >
          <span className="is-visually-hidden">Northvolt</span>
        </Link>
        <TopNav items={navigationData} dark={!darkBackground} />
        <Menu
          navigationData={props.navigationData}
          navigationSecondaryData={props.navigationSecondaryData}
          darkButton={!darkBackground}
        ></Menu>
      </div>
      {hasTitle && (
        <div className="c-page-header__text-container o-wrapper">
          <div className="o-6-of-12@large u-left@large">{titleElement()}</div>
        </div>
      )}
    </section>
  )
}

export default PageHeader
